import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 3.5a2.5 2.5 0 0 0-1 4.792M12 3.5a2.5 2.5 0 0 1 1 4.792M12 3.5V1m-1 7.292c.306.134.644.208 1 .208s.694-.074 1-.208m-2 0L6 21m7-12.708L18 21M7 15.5h10M12 14v3",
  stroke: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }